export default "__VITE_ASSET__mraeSlLT__"